import {GenericPopupConfig, GenericPopupType, GenericPopupView, PopupSpineConfig, SlotConfig, TextStyleParams} from '@gongxigames/framework/slot';
import {TextStyle} from 'pixi.js';
import {freeGamesBack, freeGamesOutroTexts, freeGamesRetriggerTexts, freeGamesTexts} from 'src/configs/SpineConfig';
import {defaultStyle} from 'src/configs/Styles';

export interface IGameGenericPopupConfig extends GenericPopupConfig {
    spine: IGamePopupSpineConfig[];
}

export interface IGamePopupSpineConfig extends PopupSpineConfig {
    value2?: SlotConfig;
}

export interface IGamePopupSpineConfig extends PopupSpineConfig {
    typedAnimation?: {
        start?: {
            name: string;
            type: number;
        }[];
        idle?: {
            name: string;
            type: number;
        }[];
    };
}

const winValueStyle: TextStyleParams = {
    align: 'center',
    fontFamily: 'PF DinDisplay Pro',
    fontWeight: 'bold',
    fill: 0xffffff
};
const buttonConfig = {
    x: -530,
    y: -150
};
const collectButtonConfig = {...buttonConfig, sprite: {rootSprite: 'spineAttachments', treeName: 'buttons.collect'}};
const startButtonConfig = {...buttonConfig, sprite: {rootSprite: 'spineAttachments', treeName: 'buttons.start'}};
const defaultFaderConfig = {
    alpha: 0.65,
    fadeDuration: 500,
    color: 0x000
};

export const freeGamesIntroPopupConfig: IGameGenericPopupConfig = {
    view: GenericPopupView.NAME,
    type: GenericPopupType.FREESPIN_INTRO,
    spine: [
        {
            spine: freeGamesBack,
            animation: {start: 'popup_start', idle: 'popup_loop'}
        },
        {
            spine: freeGamesTexts,
            typedAnimation: {
                start: [
                    {name: 'fgintro_0_start', type: 0},
                    {name: 'fgintro_1_start', type: 1},
                    {name: 'fgintro_2_start', type: 2}
                ],
                idle: [
                    {name: 'fgintro_0_loop', type: 0},
                    {name: 'fgintro_1_loop', type: 1},
                    {name: 'fgintro_2_loop', type: 2}
                ]
            },
            animation: {},
            continueButton: {...startButtonConfig, name: 'dg_banner_buttonstart'},
            value: {
                name: 'text_fgnumber',
                text: {
                    text: '',
                    style: new TextStyle({...defaultStyle, fontSize: 550}),
                    maxWidth: 1100
                },
                y: -300
            }
        }
    ],
    soundConfig: {
        buttonClickSound: 'buttonclick',
        exit: 'bannertransitionexit',
        transitionEnter: 'bannertransitionenter'
    },
    fader: defaultFaderConfig
};
export const retriggerPopupConfig: IGameGenericPopupConfig = {
    view: GenericPopupView.NAME,
    type: GenericPopupType.FREESPIN_RETRIGGER,
    spine: [
        {
            spine: freeGamesBack,
            animation: {start: 'popup_start', idle: 'popup_loop'}
        },
        {
            spine: freeGamesRetriggerTexts,
            animation: {start: 'retrigger_start', idle: 'retrigger_loop'},
            continueButton: {...startButtonConfig, name: 'dg_banner_buttonstart'},
            value: {
                name: 'text_fgnumber',
                text: {
                    text: '',
                    style: new TextStyle({...defaultStyle, fontSize: 550}),
                    maxWidth: 1100
                },
                y: -300
            }
        }
    ],
    soundConfig: {
        buttonClickSound: 'buttonclick',
        exit: 'bannertransitionexit',
        transitionEnter: 'bannertransitionenter'
    },
    closeTimeout: 3000,
    fader: defaultFaderConfig
};
export const freeGamesOutroPopupConfig: IGameGenericPopupConfig = {
    view: GenericPopupView.NAME,
    type: GenericPopupType.FREESPIN_OUTRO,
    spine: [
        {
            spine: freeGamesBack,
            animation: {start: 'popup_start', idle: 'popup_loop'}
        },
        {
            spine: freeGamesOutroTexts,
            animation: {start: 'fgoutro_start', idle: 'fgoutro_loop'},
            continueButton: {...collectButtonConfig, name: 'dg_banner_buttonstart'},
            value: {
                name: 'text_win_amount',
                text: {
                    text: '',
                    style: new TextStyle({...winValueStyle, fontSize: 370}),
                    maxWidth: 2000
                },
                y: -185
            }
        }
    ],
    soundConfig: {
        buttonClickSound: 'buttonclick',
        exit: 'bannertransitionexit',
        transitionEnter: 'bannertransitionenter'
    },
    fader: defaultFaderConfig
};
